﻿import { IBusinessResult } from "../interface/business-result";
import { getBusinessResultErrorMessage } from "./business-result";
import { showToast } from "./message";

export function showErrorMessage(br: IBusinessResult) {
    const error = getBusinessResultErrorMessage(br);
    showToast('error',error);
    console.log(error);
}